import { Typography, TypographyProps, styled } from '@mui/material';
import { WithTheme } from '@issuemanager/apps/client/theme';

const StyledTypography = styled(Typography)<WithTheme<TypographyProps>>(
  ({ theme }) => ({
    fontWeight: theme.tokens.semantic.fontWeight.emphasis.value,
    fontSize: theme.tokens.semantic.fontSize.text.body.value,
    color: theme.tokens.semantic.color.link.default.value,
    // TBD: uppercase, hover
  }),
);

export function NavigableTypography(props: TypographyProps) {
  const { children, ...rest } = props;
  return <StyledTypography {...rest}>{children}</StyledTypography>;
}
